import { useMobileAuth } from '../../context/MobileAuthContext';
import { UserCog, LogOut } from 'lucide-react';

/**
 * Sticky orange banner shown at the top of the mobile portal whenever a
 * super-admin is impersonating a worker. Mirrors the desktop impersonation
 * banner in `Layout.jsx`. Tapping "End" clears the mobile session and
 * navigates back to the SA dashboard (best-effort window.close first).
 */
export default function MobileImpersonationBanner() {
  const { isImpersonating, operator, endImpersonation } = useMobileAuth();

  if (!isImpersonating || !operator) return null;

  return (
    <div
      className="bg-orange-500 text-[var(--m-text)] px-3 py-2 flex items-center justify-between sticky top-0 z-50 shadow"
      data-testid="mobile-impersonation-banner"
    >
      <div className="flex items-center gap-2 min-w-0">
        <UserCog className="h-4 w-4 shrink-0" />
        <span className="text-xs font-medium truncate">
          Impersonating <strong>{operator?.name || 'Worker'}</strong>
          {operator?.client_id ? ` · ${operator.client_id}` : ''}
        </span>
      </div>
      <button
        type="button"
        onClick={endImpersonation}
        className="text-xs font-semibold flex items-center gap-1 px-2 py-1 rounded hover:bg-orange-600 transition-colors"
        data-testid="end-mobile-impersonation-btn"
      >
        <LogOut className="h-3.5 w-3.5" /> End
      </button>
    </div>
  );
}
